module.exports = __webpack_public_path__ + "static/media/light.67a42116.png";